import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserService } from './user/user.service';
import { DoctorService } from './doctor/doctor.service';
import { MedicalSpecialityService } from './medical-specialities/medical-speciality.service';
import { AccountsService } from './accounts/accounts.service';
import { ValidationsService } from './validations/validations.service';
import { ReportsService } from './reporting/reports.service';
import { BanksService } from './banks/banks.service';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
  ],
  providers: [
    AccountsService,
    DoctorService,
    BanksService,
    ReportsService,
    MedicalSpecialityService,
    UserService,
    ValidationsService
  ]
})
export class ApiModule { }
